import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { formatTRY, STATUS, catByValue } from "@/lib/api";
import { Trash2, Edit, CheckCircle2, Repeat } from "lucide-react";

const ALIGN = { left: "text-left", right: "text-right", center: "text-center" };
const HEADERS = [
  ["Tarih", "left"], ["İş / Adres", "left"], ["Kategori", "left"], ["Çalışan", "left"],
  ["Fiyat", "right"], ["Hakediş", "right"], ["Durum", "center"], ["İşlem", "right"],
];

const JobRow = ({ job: j, onPaid, onEdit, onDelete }) => {
  const c = catByValue(j.category);
  const s = STATUS.find((x) => x.value === j.status);
  return (
    <tr className="hover:bg-slate-50">
      <td className="p-4 font-mono text-xs text-slate-600">
        {new Date(j.date).toLocaleDateString("tr-TR")}
        {j.parent_job_id && <div className="text-[10px] text-indigo-600 flex items-center gap-1 mt-0.5"><Repeat className="h-3 w-3" /> Tekrar</div>}
      </td>
      <td className="p-4">
        <div className="font-semibold text-slate-900">{j.title}</div>
        <div className="text-xs text-slate-500 max-w-xs truncate">{j.customer_name} · {j.address}</div>
      </td>
      <td className="p-4"><Badge variant="outline" style={{ borderColor: c.hex + "50", color: c.hex }}>{c.label}</Badge></td>
      <td className="p-4 text-slate-700">{j.employee_name || <span className="text-slate-400">-</span>}</td>
      <td className="p-4 text-right font-semibold text-slate-900">{formatTRY(j.price)}</td>
      <td className="p-4 text-right text-slate-600">{formatTRY(j.employee_payment)}</td>
      <td className="p-4 text-center">
        <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${s?.color}`}>{s?.label}</span>
        {j.paid && <div className="text-[10px] text-emerald-600 mt-1">✓ Ödendi</div>}
      </td>
      <td className="p-4 text-right whitespace-nowrap">
        <Button size="sm" variant="ghost" onClick={onPaid} title={j.paid ? "Ödemeyi geri al" : "Tahsil edildi"} data-testid={`mark-paid-${j.id}`}>
          <CheckCircle2 className={`h-4 w-4 ${j.paid ? "text-emerald-600" : "text-slate-400"}`} />
        </Button>
        <Button size="sm" variant="ghost" onClick={onEdit} data-testid={`edit-job-${j.id}`}><Edit className="h-4 w-4 text-slate-500" /></Button>
        <Button size="sm" variant="ghost" onClick={onDelete} data-testid={`delete-job-${j.id}`}><Trash2 className="h-4 w-4 text-red-500" /></Button>
      </td>
    </tr>
  );
};

export const JobsTable = ({ jobs, onPaid, onEdit, onDelete }) => (
  <Card className="border-slate-200 overflow-hidden" data-testid="jobs-table">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wider">
          <tr>{HEADERS.map(([h, align]) => <th key={h} className={`${ALIGN[align]} p-4 font-medium`}>{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {jobs.length === 0 && <tr><td colSpan={8} className="text-center py-12 text-slate-400">Henüz iş eklenmedi</td></tr>}
          {jobs.map((j) => (
            <JobRow key={j.id} job={j} onPaid={() => onPaid(j)} onEdit={() => onEdit(j)} onDelete={() => onDelete(j.id)} />
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);
